import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as TyreAction from './tyre-state.action';
import { TyreStateService } from './tyre-state.service';
import { BannerService } from '../../shared/services/banner.service';

import * as TyreStateModels from '../../models/tyre/tyreState';
import * as TyrePositionModels from '../../models/tyre/tyrePosition';
import * as TyreStateValueModels from '../../models/tyre/tyreStateValue';
import * as TyreStateSearchModels from '../../models/tyre/tyreStateSearch';

import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import * as CommonModels from '../../models/commonModels';
import * as DepositeModels from '../../models/deposite/deposite';
import { StorageService } from '../../shared/services/storage.service';

export interface TyreStateModel {
  TyreStateValueList: TyreStateValueModels.TyreStateValueListModel;
  TyrePositionDictionaryList: TyrePositionModels.TyrePositionDictionaryListModel;
  TyreStateList: TyreStateModels.TyreStateListModel;
  SaveDepositeTyreState: CommonModels.SaveState;
  TyreStatePreviewList: CommonModels.Response<TyreStateModels.TyreStatePreviewModel[]>;
  Response: CommonModels.ResponseBase;
  DepositePreviewList: DepositeModels.DepositePreviewListModel;
}

class DictionaryKeys {
  public static readonly TyreStateValueList = "TyreStateModel-TyreStateValueList";
  public static readonly TyrePositionDictionaryList = "TyreStateModel-TyrePositionDictionaryList";
}


@State<TyreStateModel>({
    name: 'tyreState',
    defaults: {
      TyreStateValueList: null,
      TyrePositionDictionaryList: null,
      TyreStateList: null,
      SaveDepositeTyreState: null,
      TyreStatePreviewList: null,
      Response: null,
      DepositePreviewList: null
    }
  })

  @Injectable()

  export class TyreStateState {

    constructor(
      private helperService: HelperService,
      private tyreStateService: TyreStateService,
      private bannerService: BannerService,
      private storageService: StorageService
  ) { }

  @Selector()
  static TyreStateValueList(state: TyreStateModel) {
    return state.TyreStateValueList;
  }

  @Selector()
  static TyrePositionDictionaryList(state: TyreStateModel) {
    return state.TyrePositionDictionaryList;
  }

  @Selector()
  static TyreStateList(state: TyreStateModel) {
    return state.TyreStateList;
  }

  @Selector()
  static SaveDepositeTyreState(state: TyreStateModel) {
    return state.SaveDepositeTyreState;
  }

  @Selector()
  static TyreStatePreviewList(state: TyreStateModel) {
    return state.TyreStatePreviewList;
  }

  @Selector()
  static Response(state: TyreStateModel) {
    return state.Response;
  }

  @Selector()
  static DepositePreviewList(state: TyreStateModel) {
    return state.DepositePreviewList;
  }

  @Action(TyreAction.GetDepositeTyreState)
  getDepositeTyreState(
    context: StateContext<TyreStateModel>,
    action: TyreAction.GetDepositeTyreState
  ) {

    let errorMessage = 'Błąd pobierania szczegółów opon depozytu.';

      context.setState(
        patch({
          TyreStateList: null
        })
      );

    this.tyreStateService.getDepositeTyreState(action.Search).subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreStateList: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {

          this.helperService.SaveException('TyreAction.GetDepositeTyreState', error);

          this.bannerService.error(errorMessage);
        });
  }

  @Action(TyreAction.GetLastReturnTyreStates)
  getLastReturnedTyreState(
    context: StateContext<TyreStateModel>,
    action: TyreAction.GetLastReturnTyreStates
  ) {

    let errorMessage = 'Błąd pobierania szczegółów ostanio zwróconych opon dla danego samochodu.';

    context.setState(
      patch({
        TyreStatePreviewList: null
      })
    );

    this.tyreStateService.getLastReturnedTyreState(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyreStatePreviewList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('TyreAction.GetLastReturnTyreStates', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreAction.GetLastUtylizedTyreStates)
  getLastUtylizedTyreState(
    context: StateContext<TyreStateModel>,
    action: TyreAction.GetLastReturnTyreStates
  ) {

    let errorMessage = 'Błąd pobierania szczegółów ostanio zutylizowanych opon dla danego samochodu.';

    context.setState(
      patch({
        TyreStatePreviewList: null
      })
    );

    this.tyreStateService.getLastUtylizedTyreState(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyreStatePreviewList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('TyreAction.GetLastUtylizedTyreStates', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreAction.GetTyrePositionDictionary)
  getTyrePositionDictionary(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania listy pozycji opon.';

    let storageKey = DictionaryKeys.TyrePositionDictionaryList;

    context.setState(
      patch({
        TyrePositionDictionaryList: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.TyrePositionDictionaryList)
    {
      this.tyreStateService.getTyrePositionDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              TyrePositionDictionaryList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyrePositionDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreAction.GetTyreStateValuesDictionary)
  getTyreStateValuesDictionary(
    context: StateContext<TyreStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania listy stanów opon.';

    let storageKey = DictionaryKeys.TyreStateValueList;

    context.setState(
      patch({
        TyreStateValueList: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();


    if (!state.TyreStateValueList) {
      this.tyreStateService.getTyreStateValuesDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              TyreStateValueList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreAction.GetTyreStateValuesDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreAction.SetDepositeTyreState)
  setDeposite(
    context: StateContext<TyreStateModel>,
    action: TyreAction.SetDepositeTyreState
  ) {

    let errorMessage = 'Błąd zapisu opon depozytu';


    this.tyreStateService.setDepositeTyreState(action.RequestNewOrder).subscribe(
      (ret) => {

        if (ret.Success) {
          this.bannerService.success('Zmiany opon w depozycie zapisane. ' + ret.Message);
        } else {
          this.bannerService.error(errorMessage + ' ' + ret.Message);
        }

        context.setState(
          patch({
            TyreStateList: ret
          })
        );
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetDepositeTyreState', error);

        this.bannerService.error(errorMessage);

        let errorResponse = new TyreStateModels.TyreStateListModel();
        errorResponse.Success = false;
        errorResponse.RequestSignature = action.RequestNewOrder.RequestSignature;

        context.setState(
          patch({
            TyreStateList: errorResponse
          })
        );
      },
      () => { });
  }

  @Action(TyreAction.UtilizeTyreStatePreview)
  setTyreStatePreview(
    context: StateContext<TyreStateModel>,
    action: TyreAction.UtilizeTyreStatePreview
  ) {

    let errorMessage = 'Błąd utylizacji opon';


    this.tyreStateService.setCarUtilzation(action.RequestNewOrder).subscribe(
      (ret) => {

        if (ret.Success) {
          this.bannerService.success('Opony zutylizowane. ' + ret.Message);
        } else {
          this.bannerService.error(errorMessage + ' ' + ret.Message);
        }

        context.setState(
          patch({
            DepositePreviewList: ret
          })
        );
      },

      (error) => {
        this.helperService.SaveException('TyreAction.SetTyreStatePreview', error);

        this.bannerService.error(errorMessage);

        let errorResponse = new DepositeModels.DepositePreviewListModel();
        errorResponse.Success = false;
        errorResponse.RequestSignature = action.RequestNewOrder.RequestSignature;

        context.setState(
          patch({
            DepositePreviewList: errorResponse
          })
        );
      },
      () => {  });
  }

  @Action(TyreAction.GetCarCurrentTyreStates)
  GetCarCurrentTyreStates(
    context: StateContext<TyreStateModel>,
    action: TyreAction.GetCarCurrentTyreStates
  ) {

    let errorMessage = 'Błąd pobierania szczegółów opon zainstalowanych na samochodzie.';

    context.setState(
      patch({
        TyreStatePreviewList: null
      })
    );

    this.tyreStateService.getCarCurrentTyreStates(action.Car).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            TyreStatePreviewList: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('TyreAction.GetCarCurrentTyreStates', error);

        this.bannerService.error(errorMessage);
      });
  }
}


